import { render } from "./Sdsy.vue?vue&type=template&id=19e7f687&scoped=true"
import script from "./Sdsy.vue?vue&type=script&lang=js"
export * from "./Sdsy.vue?vue&type=script&lang=js"

import "./Sdsy.vue?vue&type=style&index=0&id=19e7f687&scoped=true&lang=css"

import exportComponent from "C:\\Users\\gaole\\Documents\\work\\dc\\www.tzspace.cn\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19e7f687"]])

export default __exports__